import { t } from "@lingui/core/macro";
import React from "react";

import { TeeSheetInfoCard } from "@whoosh/design-system/src/apps/PatronApp/screens/teesheet/components/TeeSheetInfoCard/TeeSheetInfoCard";
import { WaitlistIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { Box } from "@whoosh/design-system/src/components/primitive";
import { dateUtils } from "@whoosh/utilities";

import { RestrictionBlockProps } from "../RestrictionBlock";

type RequestTimeSlotRowHeaderProps = {
  restriction: RestrictionBlockProps;
  courseName?: string;
};

export const RequestTimeSlotRowHeader = ({
  restriction,
  courseName,
}: RequestTimeSlotRowHeaderProps) => {
  const formatStartTime = restriction?.displayStartAt
    ? dateUtils.formatHHMM(restriction?.displayStartAt)
    : t({ message: `Open`, context: "Time boundary" });
  const formatEndTime = restriction?.endAt
    ? dateUtils.formatHHMM(restriction?.endAt)
    : t({ message: `Close`, context: "Time boundary" });

  const title = restriction.displayName || t`Request Window`;

  return (
    <Box mt={4} mb={1}>
      <TeeSheetInfoCard
        subTitle={`${formatStartTime} - ${formatEndTime}`}
        title={title}
        backgroundColor="surface-user-selectable-colorC-subtlest"
        courseNames={courseName}
        icon={<WaitlistIcon />}
      />
    </Box>
  );
};
